import React, { Component } from "react";
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button, UncontrolledTooltip,
} from "reactstrap";
import {
  Link
} from "react-router-dom";
import ReactTable from "react-table";


import ConnectorService from '../../services/api/Connector'; 
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import snowflakes from "assets/img/snowflakes.png";

// import { toast } from '../../settings/shared/constants';

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";


class Project extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectDTOS:[]
      
    }
    this.state.columns = [
      {
        Header: 'Id',
        accessor: 'Id',
        sortable: true,
        show:false
      },
        {
        Header: 'Name',
        accessor: 'Name',
        sortable: true,
      }, 
      {
        Header: 'Server',
        accessor: 'Server',
        sortable: true,
      },
      {
        Header: 'Role',
        accessor: 'Role',
        sortable: true,
      },
      {
        Header: 'User',
        accessor: 'User',
        sortable: true,
      },
      {
        Header: 'Connection Timeout',
        accessor: 'ConnectionTimeout',
        sortable: true,
      },
      {
        Header: 'Warehouse',
        accessor: 'Warehouse',
        sortable: true,
      },
      {
        Header: 'Actions',
        accessor: 'Actions',  
      }
    ];  
  }
  componentDidMount() {
    this.GetAllConnectors()
 }

  GetAllConnectors  = () =>{
    ConnectorService.getAllConnectors()
    .then((response) => {
      response.connectorDTOS.length !== 0?this.renderData(response.connectorDTOS):console.log("");
    }
    );
   }

   // Edit Connector
   EditConnector = (id,name) =>{
     this.props.history.push({
      pathname: '/connectors/NewConnection',
      state: { mode:"editConnector",editId:id,}
      })
   }

  // Delete Connector
  DeleteConnector = (id) =>{
    ConnectorService.removeConnector(id).then((response) => {
      if (response.status === 'SUCCESS') {
        toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Connector Deleted Successfully!</b></i>); 
        this.GetAllConnectors();
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
     });
  }

  DeleteConnectorConfirmation = (id,name) => {
    confirmAlert({
      title: <h5>Delete Connector</h5>,
      message: 'Are you sure to delete this connector? - '+name,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.DeleteConnector(id)
        },
        {
          label: 'No',
          onClick: () => console.log('no')
        }
      ]
    });
  }


   renderData(connectordetails){
    let datas = [];   
    connectordetails.map((item, index) => {
      datas.push({
        Id:item.id,
        Name: <div><img id={"row"+index} src={snowflakes} style={{width:"20px",height:"20px",cursor:"pointer"}} alt="" /> 
         <UncontrolledTooltip placement="right" target={'row'+index} delay={0}>
             {item.type}
            </UncontrolledTooltip>&nbsp;&nbsp;{item.name}</div>,
        Server:<span title={item.server} className="overflowStyle">{item.connectorConfig.server} </span>,
        Role:item.connectorConfig.role,
        User:item.connectorConfig.username,
        ConnectionTimeout:item.connectorConfig.connectionTimeout,
        Warehouse:item.connectorConfig.warehouse,
        Actions:
       <div style={{marginLeft:6}}className="row">
          <span className="actionicon" id={'edit'+index} onClick={e => {e.preventDefault()
          this.EditConnector(item.id,item.name)}}> <i className="far fa-edit text-red mr-2" style={{color:'#007bff'}}/> &nbsp;</span> 
         <UncontrolledTooltip placement="top" target={'edit'+index} delay={0}>
             Edit
            </UncontrolledTooltip>
            <span className="actionicon" id={'delete'+index} onClick={e => this.DeleteConnectorConfirmation(item.id,item.name)}> 
            <i className="fas fa-trash-alt text-red mr-2" style={{color:'#007bff'}}/> &nbsp;</span> 
            <UncontrolledTooltip placement="top" target={'delete'+index} delay={0}>
             Delete
            </UncontrolledTooltip>
        </div>
        })
     });
     this.setState({
        connectordetails:datas
     });

}


 

  
  render() {
    return (
      <>
        <PanelHeader
          content={
            <div className="header text-center">
            
            </div>
          }
        />
        <div className="content">
        <LoadingOverlay
      active={this.state.loading}
      spinner={<ScaleLoader
        height={35}
        width={5}
        radius={2}
        margin={2}
        color={"#123abc"}
        loading={this.state.loading}
      />}
    >
          <Row>
            <Col xs={12} md={12}>
              <Card>
                <CardHeader>
                <Row className="align-items-center">
                <div className="col">
                  <CardTitle tag="h5">Connectors</CardTitle>
                 </div>
                 <div className="col text-right">
                 <Link to={{
                        pathname: '/integration/connectors'
                      }}> 
                      <span> <i className="fas fa-sync-alt mr-3" onClick={e =>this.GetAllConnectors()}/></span>
                       </Link>
                       <Link to={{
                        pathname: '/connectors/NewConnection',
                        state: { mode:"addnew" }
                      }}> 
                         <Button
                        color="primary"
                        href=""
                        size="sm"
                      >
                      Create Connection
                      </Button>
                      </Link>
                    </div>
                </Row>
                  
                </CardHeader>
                <CardBody>
                <div className="carcontent">
                <Row className="mt-12">
            <Col className="mb-12 mb-xl-0" xl="12">
            <div className="table-responsive">
            <ReactTable
         data={ this.state.connectordetails }
         columns={ this.state.columns }
         defaultPageSize={10}
         showPaginationBottom={true}
         className="-striped -highlight Providerstable"
          />
          </div>  
            </Col>
                  </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          </LoadingOverlay>

        </div>
      </>
    );
  }
}

export default Project;
